import { useEffect, useRef, useState } from "react";

/** Class name that lights a value up for a moment after it changes:
 *  "flash-up" / "flash-down" for numbers, "flash-tick" for anything else. */
export function useFlash(value) {
  const prev = useRef(value);
  const [cls, setCls] = useState("");

  useEffect(() => {
    if (prev.current === value) return undefined;
    const a = Number(prev.current);
    const b = Number(value);
    const first = prev.current == null;
    prev.current = value;
    if (first) return undefined;                 // first data arriving is not a change
    const next = Number.isFinite(a) && Number.isFinite(b) ? (b > a ? "flash-up" : "flash-down") : "flash-tick";
    setCls("");
    const raf = requestAnimationFrame(() => setCls(next));   // restart when changes come back to back
    const timer = setTimeout(() => setCls(""), 950);
    return () => { cancelAnimationFrame(raf); clearTimeout(timer); };
  }, [value]);

  return cls;
}
